<template>
  <v-snackbar
    :timeout="0"
    :multi-line="$vuetify.breakpoint.smAndDown"
    v-model="show"
    bottom
  >
    Download for a better experience
    <v-btn color="pink" text @click="show = false">
      No Thanks
    </v-btn>

    <v-btn color="success" text @click="triggerAddToHomeScreen">
      Install
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'InstallToDevice',
  data() {
    return {
      show: false,
      installPromptEvent: {}
    };
  },
  methods: {
    triggerAddToHomeScreen() {
      this.installPromptEvent.prompt();
      this.show = false;
    }
  },

  computed: {},
  components: {},
  created: function() {
    window.addEventListener('beforeinstallprompt', event => {
      // Prevent Chrome <= 67 from automatically showing the prompt
      event.preventDefault();
      // Stash the event so it can be triggered later.
      this.installPromptEvent = event;
      // Update the install UI to notify the user app can be installed

      // console.log(this.installPromptEvent);
      this.show = true;
    });
  }
};
</script>

<style lang="scss" scoped>
.install {
  display: grid;
  grid-template-columns: 7fr 1fr;
  align-items: center;
}

.message p {
  color: #fff;
  font-weight: 600;
}

.icon {
  text-align: center;
}
</style>
